import { VisuallyHidden } from '@chakra-ui/react';
import { CellProps } from '../../../types';
import { defaultHeaderRenderer } from '../../headers';
import { CellEventsHandler } from '../../formatters';
import { UserRole } from '../../../../../../store/auth/types';
import styled from '@emotion/styled';
import { StudentNumber } from './StudentNumber';
import { GetColumnInput, IColumn } from '../../types';
import { Names } from './Names';
import { Icons } from './Icons';
import { Tags } from './Tags';
import { hasPerm, P } from '../../../../../../utilities/roles/permissions';
import { ApplicantId } from './ApplicantId';
import { useTranslation } from "react-i18next";

const StudentColumnFormatter = (cellProps: CellProps, role: UserRole, isPathway?: boolean) => {
    const { t } = useTranslation('common');
  const canViewTags = role && hasPerm(role, P.TAGS_VIEW);
  const isApplicant = false; // IStudentRow represents students, not applicants

  return (
    <CellEventsHandler cellProps={cellProps}>
      <Container>
        <Row>
          <VisuallyHidden>{t('common:id')} </VisuallyHidden>
          {isApplicant ? (
            <ApplicantId cellProps={cellProps} />
          ) : (
            <StudentNumber cellProps={cellProps} role={role} isPathway={isPathway} />
          )}
          <Icons cellProps={cellProps} />
        </Row>

        <VisuallyHidden>{t('common:name2')} </VisuallyHidden>
        <Names cellProps={cellProps} />

        <VisuallyHidden>{t('common:tags')} </VisuallyHidden>
        {canViewTags && <Tags cellProps={cellProps} role={role} isPathway={isPathway} />}
      </Container>
    </CellEventsHandler>
  );
};

export const StudentColumn = ({ role, isPathway }: GetColumnInput): IColumn => ({
  item: {
    key: 'student',
    name: 'Student',
    sortable: true,
    width: 'minmax(304px, 2.5fr)',
    frozen: true,
    formatter: (cellProps: CellProps) => StudentColumnFormatter(cellProps, role!, isPathway!),
    headerRenderer: defaultHeaderRenderer,
  },
  visible: () => true,
});

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right-width: 1px;
  padding-right: 12px;
`;

const Row = styled.div`
  margin-top: 16px;
  display: flex;
  height: 16px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
